import { Trans, useTranslation } from "react-i18next";
import PopupInfoDialog from "src/SharedComponents/PopupDialog/PopUpInfoDialog";


export interface IClinicDeleteErrorParams{
    onClose: () => void;
}
const ClinicDeleteError: React.FC<IClinicDeleteErrorParams> = ({onClose}) => {
     const { t } = useTranslation();
  return (
    <PopupInfoDialog submitButtonText={t('Ok')} title={t('UnableToDeleteClinic')} onClose={onClose}>
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Trans i18nKey="UnableToDeleteClinicInstruction" />
      </div>
    </PopupInfoDialog>
  );
};

export default ClinicDeleteError;